var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "560px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-icon', _vm._g(_vm._b({
          ref: "bottom-popup-button",
          attrs: {
            "small": "",
            "color": "warning darken-1"
          }
        }, 'v-icon', attrs, false), on), [_vm._v("mdi-star-circle-outline")])];
      }
    }]),
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-card', {
    staticClass: "bottom-popup-card",
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "bottom-popup-card__img"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/member/starbucks.svg",
      "alt": "starbucks"
    }
  })])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-16 text-md-14 color-gray-7e text-center"
  }, [_vm._v(" 회원가입시 전문가 DB에 연락처, 이메일 공개를 체크하시는 전문가에게 스타벅스 쿠폰을 증정합니다. "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("(회원가입 완료후 2일이내 쿠폰발송) ")])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }